import { Component } from '@angular/core';

import { ModalController } from '@ionic/angular';

@Component({
    selector: 'app-credits',
    templateUrl: 'credits.html',
    styleUrls: [
        './styles/credits.scss'
    ]
})
export class CreditsPage {

    constructor(
        public modalController: ModalController
    ) {}

    openUrl(url: string) {
        window.open(url, '_blank');
    }

    dismiss(data?: any) {
        this.modalController.dismiss(data);
    }
}
